module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tasks text-dark"
  }, [_c('div', {
    staticClass: "tasks-header"
  }, [_c('DoFiltersFilter', {
    attrs: {
      "title": 'Briktype',
      "tags": _vm.filterLabels,
      "selectedTags": _vm.selectedFilterSubjectTypes
    },
    on: {
      "select": _vm.toggleFilterSubjectTypes,
      "clear": function($event) {
        _vm.selectedFilterSubjectTypes = []
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tasks-header__right"
  }, [(_vm.isSubmittingTask) ? _c('div', {
    staticClass: "do-spinner"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    staticStyle: {
      "width": "150px",
      "height": "38px"
    },
    on: {
      "click": _vm.setCreateNewTask
    }
  }, [_vm._v("\n      " + _vm._s(_vm.i18n[_vm.locale]['create_tasks']) + "\n    ")])])], 1), _vm._v(" "), _c('table', {
    staticClass: "d-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "250px"
    }
  }, [_c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.closeSearchGroup),
      expression: "closeSearchGroup"
    }],
    staticClass: "d-search__hidden__group",
    class: {
      'isShow': _vm.isSearchHiddenFadeIn
    },
    on: {
      "click": function($event) {
        return _vm.setIsSearchHidden(false)
      }
    }
  }, [_c('span', {
    staticClass: "icon-search5"
  }), _vm._v(" "), (_vm.isSearchHidden) ? _c('div', {
    staticClass: "d-search__hidden__group--hide"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['search_task']) + "\n          ")]) : _c('div', {
    staticClass: "d-search__hidden__group--show"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    ref: "query_input",
    attrs: {
      "type": "search",
      "placeholder": _vm.i18n[_vm.locale]['search_task']
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('th', {
    staticClass: "d-table__number",
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['teaching_short']))]), _vm._v(" "), _c('th', {
    staticClass: "d-table__number",
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['other_short']))]), _vm._v(" "), _c('th', {
    staticClass: "d-table__number",
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['prep']))]), _vm._v(" "), (_vm.isSchoolFeatureLocalePool) ? _c('th', {
    staticClass: "d-table__number",
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['pool']))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_c('span', {
    staticClass: "icon-user3"
  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['teacher']))]), _vm._v(" "), _c('th', {
    staticClass: "d-table__number",
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['sum']) + " : " + _vm._s(_vm.calcAllHours))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.searchedTasks), function(task) {
    return _c('tr', {
      key: task.id
    }, [_c('td', [_c('div', {
      staticClass: "task__name"
    }, [_c('div', {
      class: [{
        'td-subject--hidden': !task.can_schedule
      }, {
        'td-subject': task.can_schedule
      }],
      style: ({
        'background-color': task.color
      }),
      on: {
        "click": function($event) {
          return _vm.setEditTask(task)
        }
      }
    }, [_vm._v(_vm._s(task.name) + "\n          ")])])]), _vm._v(" "), _c('td', {
      staticClass: "d-table__number"
    }, [_vm._v(_vm._s(task.timeTeaching))]), _vm._v(" "), _c('td', {
      staticClass: "d-table__number"
    }, [_vm._v(_vm._s(task.timeTasks))]), _vm._v(" "), _c('td', {
      staticClass: "d-table__number"
    }, [_vm._v(_vm._s(task.timePrep))]), _vm._v(" "), (_vm.isSchoolFeatureLocalePool) ? _c('td', {
      staticClass: "d-table__number"
    }, [_vm._v(_vm._s(task.timePool))]) : _vm._e(), _vm._v(" "), _c('td', {
      class: {
        'd-select-lookalike': !_vm.isActiveDSelect(task.id) && task.user_calendar_ids.length < 1
      },
      attrs: {
        "aria-placeholder-label": _vm.i18n[_vm.locale]['search_and_select']
      },
      on: {
        "click": function($event) {
          return _vm.setActiveDSelect(task)
        }
      }
    }, [(_vm.isActiveDSelect(task.id)) ? _c('DSelectCalendarIds', {
      directives: [{
        name: "on-clickaway",
        rawName: "v-on-clickaway",
        value: (_vm.closeDSelect),
        expression: "closeDSelect"
      }, {
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          onShow: function () { return _vm.usersWithEvents(task).length > 0; },
          arrow: true,
          placement: 'bottom'
        }),
        expression: "{\n                              onShow: () => usersWithEvents(task).length > 0,\n                              arrow: true,\n                              placement : 'bottom'\n                            }"
      }],
      attrs: {
        "show": _vm.activeDSelectShow,
        "itemType": "USER",
        "preSelectedItems": task.user_calendar_ids,
        "itemsThatCantBeDeleted": _vm.usersWithEvents(task),
        "showTags": true,
        "content": _vm.getUserNames(_vm.usersWithEvents(task)) + ' ' + _vm.i18n[_vm.locale]['has_scheduled_and_cant_be_deleted']
      },
      on: {
        "update": function($event) {
          return _vm.setSelectedUsers($event, task)
        }
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.isActiveDSelect(task.id) && task.user_calendar_ids.length > 0) ? _c('div', {
      staticClass: "task__users"
    }, _vm._l((_vm.getUsers(task.user_calendar_ids)), function(user) {
      return _c('p', [_vm._v(_vm._s(user))])
    }), 0) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "d-table__number"
    }, [_vm._v(_vm._s(_vm.getCalcTotal(task)))])])
  }), 0)]), _vm._v(" "), (_vm.tasks.length < 1) ? _c('div', {
    staticClass: "explainer-div"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_tasks_created']))]) : _vm._e(), _vm._v(" "), (_vm.tasks.length > 0 && _vm.filteredTasks.length < 1) ? _c('div', {
    staticClass: "explainer-div"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_tasks_matching']) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.isTaskModal) ? _c('CreateTask', {
    attrs: {
      "editTask": _vm.editTask,
      "activeFilter": _vm.theFilter
    },
    on: {
      "close": _vm.closeUpdateTask,
      "create": _vm.createTask,
      "updateTask": _vm.updateTask
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a5458594!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubjectsDistribution/SubjectsDistributionTasks.vue
// module id = 1736
// module chunks = 1